import React from 'react';
import { Quote } from 'lucide-react';

export default function Testimonials() {
  const testimonials = [
    {
      quote: "Without a doubt, we would not be in the position we are now without their expertise and guidance. Our Technology Services department has gone from little to no respect and faith from our stakeholders, to the most counted on to complete the task with efficiency and timeliness.",
      position: "Executive Director of Technology and Information – Public School District in Texas"
    },
    {
      quote: "With their innovative solution, our district was able to add triple the number of Virtual Machines at the same cost as our first deployment. Their turnkey operation did everything we needed, their team was very professional, and they were on-time with all their work.",
      position: "Chief Technology Officer - Public School District in Texas"
    },
    {
      quote: "The UCX team is professional, knowledgeable, and accommodating. In less than a year's time, the City now operates on a different network platform, has fewer servers, has upgraded its website management controls and has implemented a new IP phone system.",
      position: "City Manager – City Government"
    }
  ];

  return (
    <section id="testimonials" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-4xl font-bold text-center text-gray-900 mb-4">
          What Our Clients Say
        </h2>
        <p className="text-xl text-gray-600 text-center mb-16 max-w-3xl mx-auto">
          Join hundreds of satisfied clients who trust us with their IT infrastructure
        </p>
        
        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="group relative">
              <div className="absolute inset-0 bg-gradient-to-r from-blue-500 to-blue-600 rounded-2xl blur-xl opacity-0 group-hover:opacity-10 transition-opacity duration-500"></div>
              <div className="relative bg-white p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100">
                <Quote className="h-8 w-8 text-blue-500 mb-4 transform group-hover:rotate-12 transition-transform duration-300" />
                <p className="text-gray-700 text-lg leading-relaxed mb-6">{testimonial.quote}</p>
                <div>
                  <p className="text-sm text-gray-600">{testimonial.position}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}